module.exports = __webpack_public_path__ + "static/media/2.57da9348.JPG";